setTimeout(() => {
  const selectArtwork = document.querySelector(
    '[data-option="Select Artwork Type"]'
  );
  const frameTypeDropdown = document.querySelector(".custom_drop-2");

  if (selectArtwork && frameTypeDropdown) {
    selectArtwork.addEventListener("change", (event) => {
      const selectedOption = event.target.value;
      if (selectedOption === "Framed Canvas") {
        frameTypeDropdown.style.display = "none";
      } else {
        frameTypeDropdown.style.display = "block";
      }
    });
  } else {
    console.error("One or more elements not found.");
  }
}, 5000);
